import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { validateFieldLanguage } from "../../Utils/languageValidation";

import {
  clearState,
  fetchLegalPage,
  updateLegalPage,
} from "../../redux/Slices/LegalPagesSlice";

const EditPrivacy = () => {
  const dispatch = useDispatch();
  const key = "privacy";

  const { pages, isLoading, error, success } = useSelector(
    (state) => state.legal
  );
  const privacy = pages?.privacy;

  const [formData, setFormData] = useState({
    title_ar: "",
    title_en: "",
    content_ar: "",
    content_en: "",
    is_active: 1,
  });

  useEffect(() => {
    dispatch(clearState());
    dispatch(fetchLegalPage(key));
  }, [dispatch]);

  useEffect(() => {
    if (!privacy) return;
    setFormData({
      title_ar: privacy.title_ar || "",
      title_en: privacy.title_en || "",
      content_ar: privacy.content_ar || "",
      content_en: privacy.content_en || "",
      is_active: privacy.is_active ? 1 : 0,
    });
  }, [privacy]);

  useEffect(() => {
    if (success) toast.success(success);
    if (error) toast.error(error);
    if (success || error) dispatch(clearState());
  }, [success, error, dispatch]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // التحقق من لغة الحقول قبل الإرسال
    const titleArError = validateFieldLanguage(formData.title_ar, "ar");
    if (titleArError) return toast.error(titleArError);
    const titleEnError = validateFieldLanguage(formData.title_en, "en");
    if (titleEnError) return toast.error(titleEnError);
    const contentArError = validateFieldLanguage(formData.content_ar, "ar");
    if (contentArError) return toast.error(contentArError);
    const contentEnError = validateFieldLanguage(formData.content_en, "en");
    if (contentEnError) return toast.error(contentEnError);

    dispatch(clearState());
    dispatch(updateLegalPage({ key, formData }));
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 9,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
    transition: "border-color 0.2s, box-shadow 0.2s"
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    color: "#64748b",
    display: "block",
    marginBottom: 6,
    textAlign: "right"
  };

  const focusHandler = (e) => {
    e.target.style.borderColor = "var(--main-color)";
    e.target.style.boxShadow = "0 0 0 3px rgba(228, 109, 23, 0.1)";
  };

  const blurHandler = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
  };

  return (
    <div className="container-fluid" style={{ direction: "rtl", padding: "4px 0" }}>
      <style>{`
        .legal-custom-select {
          width: 100% !important;
          padding: 10px 14px !important;
          padding-left: 40px !important;
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          font-size: 14px !important;
          outline: none !important;
          box-sizing: border-box !important;
          background-color: #fff !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
          background-repeat: no-repeat !important;
          background-position: left 14px center !important;
          background-size: 16px !important;
          cursor: pointer !important;
          transition: border-color 0.2s, box-shadow 0.2s !important;
        }
        .legal-custom-select:focus {
          border-color: var(--main-color) !important;
          box-shadow: 0 0 0 3px rgba(228, 109, 23, 0.1) !important;
        }
      `}</style>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <h4 style={{ margin: 0, fontWeight: 800, color: "#0f172a", fontSize: 20 }}>🔒 تعديل سياسة الخصوصية</h4>
          <p style={{ margin: "2px 0 0", color: "#64748b", fontSize: 13 }}>تحديث سياسات الحماية وخيارات الخصوصية للمستخدمين</p>
        </div>
      </div>

      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "24px", boxShadow: "0 1px 4px rgba(0,0,0,.04)" }}>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
            <div>
              <label style={labelStyle}>العنوان (عربي) *</label>
              <input
                required
                type="text"
                name="title_ar"
                value={formData.title_ar}
                onChange={handleInputChange}
                style={inputStyle}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="أدخل عنوان السياسة بالعربية..."
              />
            </div>

            <div>
              <label style={labelStyle}>العنوان (English)</label>
              <input
                type="text"
                name="title_en"
                value={formData.title_en}
                onChange={handleInputChange}
                style={inputStyle}
                onFocus={focusHandler}
                onBlur={blurHandler}
                dir="ltr"
                placeholder="Enter title in English..."
              />
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
            <div>
              <label style={labelStyle}>المحتوى (عربي) *</label>
              <textarea
                required
                name="content_ar"
                value={formData.content_ar}
                onChange={handleInputChange}
                rows="10"
                style={{ ...inputStyle, resize: "vertical" }}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="اكتب بنود سياسة الخصوصية بالتفصيل هنا..."
              />
            </div>

            <div>
              <label style={labelStyle}>المحتوى (English)</label>
              <textarea
                name="content_en"
                value={formData.content_en}
                onChange={handleInputChange}
                rows="10"
                style={{ ...inputStyle, resize: "vertical" }}
                onFocus={focusHandler}
                onBlur={blurHandler}
                dir="ltr"
                placeholder="Write privacy policy details here..."
              />
            </div>
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={labelStyle}>حالة الصفحة</label>
            <select
              name="is_active"
              value={formData.is_active}
              onChange={handleInputChange}
              className="legal-custom-select"
            >
              <option value={1}>🟢 مفعلة (تظهر للمستخدمين)</option>
              <option value={0}>🔴 غير مفعلة (مخفية)</option>
            </select>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              type="submit"
              disabled={isLoading}
              style={{
                padding: "10px 28px",
                borderRadius: 10,
                border: "none",
                background: isLoading ? "#c7d2fe" : "linear-gradient(135deg,var(--main-color),var(--main-light))",
                color: "#fff",
                fontWeight: 700,
                cursor: isLoading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontSize: 14
              }}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm" />
                  جاري الحفظ...
                </>
              ) : (
                <>حفظ التعديلات</>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPrivacy;
